import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { getIn } from "formik";
import React from "react";
import CustomTextArea from "../../../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../../../../../components/OutlineCard";
import Text from "../../../../../../../../../../../components/Text";
import { ExamCheckboxSection } from "./InitialPsychotherapyConstant";

interface CheckboxCardSectionsProps {
  formik: any;
  sections: ExamCheckboxSection[];
}

// 3 columns
const columnSize = 12 / 3;

// Each section is stored as a comma-separated string of selected option names,
// e.g. { appearance: "cleanGroomed,tattoos" }, plus a `${key}Note` free text.
const parseSelected = (value: unknown): string[] =>
  typeof value === "string" ? value.split(",").filter(Boolean) : [];

const CheckboxCardSections: React.FC<CheckboxCardSectionsProps> = ({
  formik,
  sections,
}) => (
  <Flex flexDirection="column" gap={2} width="100%">
    {sections.map((section) => {
      const selected = parseSelected(getIn(formik.values, section.key));
      const noteKey = section.noteKey ?? `${section.key}Note`;

      const toggleOption = (name: string, checked: boolean) => {
        // rebuild in the canonical item order so the string is stable
        const next = section.items
          .map((it) => it.name)
          .filter((n) => (n === name ? checked : selected.includes(n)));
        formik.setFieldValue(section.key, next.join(","));
      };

      return (
        <OutlineCard key={section.key}>
          <Flex flexDirection="column" gap={1} width="100%">
            <Text variant="subtitle1" fontWeight="bold">
              {section.label}
            </Text>

            <Grid container spacing={0.2}>
              {section.items.map((item) => (
                <Grid
                  key={item.name}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: columnSize,
                  }}
                >
                  <FormControlLabel
                    sx={{ mr: 0 }}
                    control={
                      <Checkbox
                        sx={{ py: 0.25 }}
                        name={`${section.key}.${item.name}`}
                        checked={selected.includes(item.name)}
                        onChange={(_, checked) =>
                          toggleOption(item.name, checked)
                        }
                      />
                    }
                    label={<Text fontSize="14px">{item.label}</Text>}
                  />
                </Grid>
              ))}

              <Grid
                sx={{
                  mt: 1,
                }}
                size={12}
              >
                <CustomTextArea
                  label="Add Note"
                  name={noteKey}
                  placeholder={`Notes for ${section.label}...`}
                  value={getIn(formik.values, noteKey) || ""}
                  onChange={(e) =>
                    formik.setFieldValue(noteKey, e.target.value)
                  }
                  minRows={2}
                />
              </Grid>
            </Grid>
          </Flex>
        </OutlineCard>
      );
    })}
  </Flex>
);

export default CheckboxCardSections;
